
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Réussir une carte de visite professionnelle : conseils et design",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez à concevoir une carte de visite professionnelle percutante : éléments essentiels, astuces de design et conseils pour marquer les esprits efficacement.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment réussir votre plus belle carte de visite professionnelle ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "C’est un petit bout de carton passant de main en main. Il est toujours dans le paysage malgré les siècles, malgré l’avènement du numérique et des réseaux sociaux.",
        },
      ],
    };
  },
};
